export default __webpack_public_path__ + "static/media/Red_service.d31fa40e.jpg";